import { tsValidateString, tsValidateValue } from '@nu-art/ts-common';
import { smartDocStaticParamType_PhysicianNotes } from './types.js';
import { Validator_SmartDocStaticParamType } from '../_base/index.js';
import { Validator_SmartDocParamResolver_PhysicianNotes } from '../../../smart-doc-param-resolver/index.js';
export const Validator_SmartDocStaticParam_PhysicianNotes = {
    key: tsValidateString(),
    type: Validator_SmartDocStaticParamType,
    subType: tsValidateValue([smartDocStaticParamType_PhysicianNotes]),
    resolver: Validator_SmartDocParamResolver_PhysicianNotes,
};
//# sourceMappingURL=validator.js.map